module.exports = __webpack_public_path__ + "img/swiper3.ee428f4a.jpg";